import { Backdrop, CircularProgress } from "@mui/material";
import { useLoaderStore } from "../store/useLoaderStore";

const Loader = ({ isLoading }: any) => {
  const loading = useLoaderStore((state) => state.loading);

  return (
    <Backdrop
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
